<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="repairRegistrationVo.pkid > 0 ? '编辑' : '新建'"
      class="replacementBill-edit"
      width="1200px"
      top="2vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="repairRegistrationVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="条形码">
            <el-input v-model="repairRegistrationVo.barcode" @keyup.enter.native="getDeliveryBillByCode()" @blur="addBarcode"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="原发货单号">
            <el-input v-model="repairRegistrationVo.oldDeliveryBillNo"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="售出月数">
            <el-input v-model="repairRegistrationVo.saleMonth"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="物料代码">
            <el-input v-model="repairRegistrationVo.materialNo" placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectRepairMaterial.open()">
                选择
              </el-button>
            </el-input>
            <material-select ref="selectRepairMaterial" @select="selectMaterial"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料名称">
            <el-input v-model="repairRegistrationVo.materialName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料型号">
            <el-input v-model="repairRegistrationVo.specification"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="3个月内维修次数">
            <el-input v-model="repairRegistrationVo.frequency" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="批次数量">
            <el-input v-model="repairRegistrationVo.batchQuantity" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="停止服务时间">
            <el-date-picker
                v-model="repairRegistrationVo.stopServiceTime"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户名称">
            <el-input v-model="repairRegistrationVo.customerName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="终端客户">
            <el-input v-model="repairRegistrationVo.terminalCustomerName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收货人/客户联系人">
            <el-input v-model="repairRegistrationVo.consignee"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户/联系方式">
            <el-input v-model="repairRegistrationVo.consigneeContact"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="返厂快递单号">
            <el-input v-model="repairRegistrationVo.returnCourierNO"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接收日期">
            <el-date-picker
                v-model="repairRegistrationVo.receiveTime"
                style="width: 190px"
                disabled
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vm-separate">
        <el-form-item label="客户地址">
          <el-input v-model="repairRegistrationVo.customerAddress" type="textarea"/>
        </el-form-item>
        <el-form-item label="送修单位">
          <el-input v-model="repairRegistrationVo.fixUnitName" type="textarea"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="报修故障">
          <el-input v-model="repairRegistrationVo.faultReporting" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="接机备注">
          <el-input v-model="repairRegistrationVo.jjNote" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </div>

      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="repairRegistrationVo.attachments"
            ref="payData1"
            :data="repairRegistrationVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UploadFile from "@/components/UploadFile";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";

  export default {
    name: "RepairRegistrationQSEdit",
    components: {CustomerSelect, MaterialSelect, UploadFile},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        options: [
          {
            value: "PCBA外协",
            label: "PCBA外协",
            children: [{
                         value: "虚焊",
                         label: "虚焊",
                       },
                       {
                         value: "空焊",
                         label: "空焊",
                       },
                       {
                         value: "少件",
                         label: "少件",
                       },
                       {
                         value: "连焊",
                         label: "连焊",
                       },
                       {
                         value: "撞件",
                         label: "撞件",
                       },
                       {
                         value: "错件",
                         label: "错件",
                       },
                       {
                         value: "异物",
                         label: "异物",
                       },
                       {
                         value: "立件/立碑",
                         label: "立件/立碑",
                       },
                       {
                         value: "偏移",
                         label: "偏移",
                       },{
                         value: "反向",
                         label: "反向",
                       },
                       {
                         value: "铜箔断裂",
                         label: "铜箔断裂",
                       },
                       {
                         value: "坏件",
                         label: "坏件",
                       },
            ],
          },
          {
            value: "材料不良",
            label: "材料不良",
          },
          {
            value: "测试正常",
            label: "测试正常",
          },
          {
            value: "生产作业不良",
            label: "生产作业不良",
            children: [{
                         value: "组装不良",
                         label: "组装不良",
                       },
                       {
                         value: "焊接不良",
                         label: "焊接不良",
                       },
                       {
                         value: "漏写程序",
                         label: "漏写程序",
                       },
            ],
          },
          {
            value: "待分析",
            label: "待分析",
          },
        ],
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        repairRegistrationVo: {
          pkid: "",
          billNo: "",
          type: 20,
          receiveTime: "",
          batchQuantity: "",
          productBarCode: "",
          accomplishCodeDesc: "",
          processInCode: "",
          accomplishCode: "",
          nodeCode: "",
          creatTime: "",
          receiveName: "",
          barcode: "",
          jjNote: "",
          materialId: "",
          materialNo: "",
          materialName: "",
          customerAddress: "",
          fixUnitName: "",
          customerName: "",
          returnCourierNO: "",
          deliverCourierNO: "",
          attachments: [],
          isWarranty: true,
          isCharge: true,
          hardwareVersion: "",
          softwareVersion: "",
          historicalAlarms: "",
          faultReporting: "",
          faultActual: "",
          faultTime: "",
          maintenanceRecord: "",
          repairId: "",
          repairName: "",
          terminalCustomerName: "",
          replacementParts: "",
          note: "",
          status: "",
          repairTime: "",
          chargedAmount: "",
          workerNo: "",
          frequency: "",
          faultType: "",
          stopServiceTime: "",
          oldDeliveryBillNo: "",
          saleMonth: "",
          details: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
          orderReturnReasonName: {required: true, message: "退货原因不能为空", trigger: "blur"},
          typeName: {required: true, message: "退货类型不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.repairRegistrationVo.pkid = row.pkid;
          if (this.repairRegistrationVo.pkid > 0) {
            this.getData();
          }
        }
      },
      fileDelete(index) {
        this.repairRegistrationVo.attachments.splice(index, 1);
      },
      getDeliveryBillByCode() {
        if (this.repairRegistrationVo.barcode) {
          this.$http.get("basic", `deliveryBillDetailSerialNoes/getDeliveryBillByCode/${this.repairRegistrationVo.barcode}`).then((res) => {
            console.log(res.data);
            this.repairRegistrationVo.oldDeliveryBillNo = res.data.deliveryBillNo;
            this.repairRegistrationVo.saleMonth = res.data.saleMonth;
            this.repairRegistrationVo.materialNo = res.data.materialNo;
            this.repairRegistrationVo.materialName = res.data.materialName;
            this.repairRegistrationVo.specification = res.data.specification;
            this.repairRegistrationVo.frequency = res.data.repairRegistrations.length;
            if (!res.data.materialNo && res.data.repairRegistrations.length>0) {
              let model =res.data.repairRegistrations[0];
              this.repairRegistrationVo.materialNo = model.materialNo;
              this.repairRegistrationVo.materialName = model.materialName;
              this.repairRegistrationVo.specification = model.specification;
            }
          }).catch(() => {
            this.$message.error("未查询到条码对应的物料");
          });
        }

      },
      // getRepairRegistrationInfo() {
      //   this.$http
      //     .get("basic", `repairRegistrations/selectListByCode/${this.repairRegistrationVo.barcode}`)
      //     .then(resp => {
      //       console.log(resp.data);
      //       this.repairRegistrationVo.frequency =resp.data.length;
      //     });
      // },
      getData() {
        this.$http
          .get("basic", `repairRegistrations/${this.repairRegistrationVo.pkid}`)
          .then(resp => {
            this.repairRegistrationVo = resp.data;
            if (this.repairRegistrationVo.details.length>0) {
              this.repairRegistrationVo.details.forEach((item) => {
                if (item.problemType) {
                  item.problemType = item.problemType.split("/");
                }
              });
            }
            this.repairRegistrationVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          });
      },
      getDetails(row, index) {
        console.log(row);
        // this.repairRegistrationVo.details[index].materialId = row.id;
        this.repairRegistrationVo.details[index].productName = row.name;
        this.repairRegistrationVo.details[index].productModel = row.no;
      },
      addBarcode() {
        let barcode = this.repairRegistrationVo.barcode.trim();
        if (barcode) {
          // 处理特定格式的条形码：以《*!开头且包含FSerialNum
          if (barcode.startsWith('《*！') && barcode.includes('FSerialNum：')) {
            // 正则表达式：匹配FSerialNum：后面到FAuxQty之前的内容
            const match = barcode.match(/FSerialNum：([\s\S]*?)FAuxQty/);
            if (match && match[1]) {
              barcode = match[1].trim().replace("|","");
            }
          }
          // 处理包含2个'-'的条形码：截取两个'-'中间的字符串
          else if ((barcode.match(/-/g) || []).length === 2) {
            // 正则表达式：匹配两个'-'中间的内容
            const match = barcode.match(/-(.*?)-/);
            if (match && match[1]) {
              barcode = match[1].trim();
            }
          }
          // 处理包含3个'-'的条形码：截取第二个'-'和第三个'-'中间的字符串
          else if ((barcode.match(/-/g) || []).length === 3) {
            // 使用字符串分割方法：先分割成数组，再取第2个元素
            const parts = barcode.split('-');
            if (parts.length === 4) {
              barcode = parts[2].trim();
            }
          }
          // 处理包含4个':'的条形码：截取第三个':'和第四个':'中间的字符串
          else if ((barcode.match(/:/g) || []).length === 4) {
            // 使用字符串分割方法：先分割成数组，再取第3个元素
            const parts = barcode.split(':');
            if (parts.length === 5) {
              barcode = parts[3].trim();
            }
          }
          this.repairRegistrationVo.barcode = barcode;
        }
      },
      addDetails() {
        this.repairRegistrationVo.details.push({
          pkid: 0,
          masterId: 0,
          shapeCode: "",
          faultDesc: "",
          specifications: "",
          afterSpecifications: "",
          problemType: "",
          positionNo: "",
          maintenanceRecord: "",
        });
      },
      oneDelete(index) {
        this.repairRegistrationVo.details.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.repairRegistrationVo.attachments.push(params);
        }
      },
      selectCustomer(row) {
        console.log(row);
        this.repairRegistrationVo.customerName = row.customerName;
        this.repairRegistrationVo.customerId = row.customerID;
        if (row.customerDeliveryAddresses) {
          this.repairRegistrationVo.customerAddress = row.customerDeliveryAddresses;

        }
      },
      selectCustomer2(row) {
        this.repairRegistrationVo.terminalCustomerName = row.customerName;
        this.repairRegistrationVo.terminalCustomerId = row.customerID;
        this.repairRegistrationVo.customerAddress = row.customerDeliveryAddresses;
      },
      selectMaterial(row) {
        this.repairRegistrationVo.materialId = row.id;
        this.repairRegistrationVo.materialNo = row.no;
        this.repairRegistrationVo.materialName = row.name;
        this.repairRegistrationVo.specification = row.zmyxh;
        console.log(this.repairRegistrationVo);
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.repairRegistrationVo.details.length>0) {
              this.repairRegistrationVo.details.forEach((item) => {
                if (item.problemType) {
                  console.log(item.problemType);
                  item.problemType = item.problemType.join("/");
                }
              });
            }
            this.submitLoading = true;
            if (this.repairRegistrationVo.pkid > 0) {
              this.$http
                .put("basic", "repairRegistrations", this.repairRegistrationVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "repairRegistrations/insertByJJ", this.repairRegistrationVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  top: 3% !important;
  left: 0 !important;
}
</style>